import React from 'react';
import StatisticsPage from '../components/supplierStats/StatisticsPage';
export default function SupplierStatsProductDetail() {
  return <StatisticsPage kind="product-detail" />;
}
